module.exports = __webpack_public_path__ + "static/img/building.e1cfc6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/building.png
// module id = /wfU
// module chunks = 2